import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import moment from 'moment-timezone'
import { formatearImporte } from '@/util/importe'

require('./plugins/vue-axios')
require('./plugins/vue-cookies')
require('./plugins/vee-validate')

// El contexto de sucursal/caja vivía en cookies de dominio compartido y se
// filtraba entre empresas. Se borran al arrancar para que no sigan viajando.
import { limpiarCookiesLegacy } from '@/store/modules/sucursales/contexto'
limpiarCookiesLegacy()


moment.tz.setDefault("America/Argentina/Cordoba")
moment.locale('es');
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.prototype.$updateBus = new Vue;

Vue.filter('convertPesoArg', function (value) { return `$ ${new Intl.NumberFormat("de-DE").format(value)}` })
// Importe contable: separador de miles y siempre dos decimales, sin símbolo.
Vue.filter('importe', formatearImporte)
Vue.filter('convertPorcentaje', function (value) {
  let val = parseFloat(value);
  if (isNaN(val)) val = 0;
  return `${new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(val)}%`;
});

Vue.config.errorHandler = function (error, vm, info) {
  // Manejar el error aquí
  console.error('Error en el componente:', error);
  console.error('Componente:', vm);
  console.error('Información adicional:', info);
}

// Los tokens son compartidos por todas las pestañas del navegador. Si en otra
// pestaña se cerró la sesión (o la caja), esta también sale; si entró otro
// usuario, se recarga para no seguir mostrando al anterior mientras los
// pedidos ya viajan con el token del nuevo (Venecia, 22/10/2026).
function usuarioDelToken(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return payload.uid || payload.user_id
  } catch (e) {
    return null
  }
}

window.addEventListener('storage', (e) => {
  if (e.key !== 'token_access') return
  if (!e.newValue) {
    if (store.state.auth.isLogged) store.dispatch('auth/logOut')
  } else if (e.oldValue && usuarioDelToken(e.oldValue) !== usuarioDelToken(e.newValue)) {
    window.location.reload()
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
